import styled from 'styled-components'

import { bh, grayDarkest } from '../../../utils/style-utils'

export const Wrapper = styled.div`
  min-height: ${bh * 20}px;
  z-index: 1;
  background: ${grayDarkest};
`
